export default "__VITE_ASSET__CGUc81hb__"